import React from "react";
import { Link } from "react-router-dom";
import aiImage from "../../../assets/EMAIL1.jpg";
import strategyImage from "../../../assets/EMAIL.jpg";

export default function EmailContentMarketing() {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Email & Content Marketing"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-90"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Email & Content Marketing
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Develop automated email journeys and SEO-rich, AI-powered blogs, whitepapers, and guides
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Email & Content Marketing"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-white text-center lg:text-left">
                Email & Content Marketing
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Develop automated email journeys and SEO-rich, AI-powered blogs, whitepapers, and guides.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed text-center lg:text-left">
                Our integrated approach combines compelling content creation with strategic email marketing to nurture leads and drive customer engagement throughout their journey.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
            Our Services
          </h2>
          
          <div className="flex flex-wrap justify-center gap-8">
            {/* Content Analysis */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Content Analysis
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Comprehensive content analysis to ensure alignment with e-learning goals, delivered in an effective and professional way.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Design and Development for E-Learning */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Design and Development for E-Learning
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Design customized educational units that align with the institution's identity and meet its academic goals.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Story Creation */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Story Creation
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Transform educational concepts into visual stories that simplify ideas and present them more effectively.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Language Enhancement */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Language Enhancement
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Develop educational content in multiple languages, including Arabic and English, tailored to specific needs and accessible to all.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Professional Voiceover Recording */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Professional Voiceover Recording
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Provide high-quality voiceover recording services to enhance the educational experience and make content more engaging.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Recording with AI */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
                  <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Recording with AI
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Utilize AI technology to create professional voiceovers and audio content that enhances learning experiences.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* 3D Animation */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                3D Animation
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Create stunning 3D animations that bring educational content to life and enhance visual learning experiences.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Scenario Building */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Scenario Building
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Design educational scenarios that place learners in realistic settings to improve understanding and application.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Simulation Programs */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Simulation Programs
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Develop simulation environments where learners can practice content through applied experiences.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Gamification */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Gamification
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Transform content into an interactive experience that boosts learner engagement and progress.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Knowledge Assessment Programs */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2v1a2 2 0 002 2h4a2 2 0 002-2V3a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm2.707 4.707a1 1 0 000-1.414L5.414 7H9a1 1 0 100-2H4a1 1 0 00-1 1v4a1 1 0 102 0V8.414l1.293 1.293a1 1 0 001.414 0z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Knowledge Assessment Programs
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Provide detailed evaluation tools to measure learners' engagement and assess their understanding of the content.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Interactive Programs */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Interactive Programs
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Create interactive content that allows learners to engage actively with educational materials.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Training Strategies and Consulting */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Training Strategies and Consulting
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Provide tailored training strategies and expert consultation to address the specific needs of e-learning platforms.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Evaluation */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Evaluation
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Deliver consistent assessments of educational content to ensure alignment with objectives.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Content Segmentation Services */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Content Segmentation Services
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Develop structured content divisions to help achieve learning goals effectively.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Translation Service */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 12.236 11.618 14z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Translation Service
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Professional content translation to ensure cultural and educational alignment across various languages.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Chat Programs */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Chat Programs
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Design interactive chat programs allowing learners to pose questions and engage with content directly.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white">
            Why Choose Us?
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold text-center mb-12 text-[#B31F7E]">
            Our Unique Strengths
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cultural and Linguistic Alignment */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold mb-3 text-[#B31F7E]">
                Cultural and Linguistic Alignment
              </h4>
            </div>

            {/* Interactive and Engaging Experiences */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold mb-3 text-[#B31F7E]">
                Interactive and Engaging Experiences
              </h4>
            </div>

            {/* Personalized Content Expertise */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold mb-3 text-[#B31F7E]">
                Personalized Content Expertise
              </h4>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}